module.exports = __webpack_public_path__ + "static/img/b103.0488938c.png";